import { render, staticRenderFns } from "./qDialog.vue?vue&type=template&id=c2bd020a&scoped=true&"
import script from "./qDialog.vue?vue&type=script&lang=js&"
export * from "./qDialog.vue?vue&type=script&lang=js&"
import style0 from "./qDialog.vue?vue&type=style&index=0&id=c2bd020a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bd020a",
  null
  
)

export default component.exports